import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Day, WeekRow } from 'components/Dealer/DealerContact/HoursInfo';
import Icon from 'components/Shared/Icon';
import clockIcon from 'public/static/images/dealer_pages/clock.svg';
import { DaysOfWeek, DealerHours, DayOrder } from 'lib/models/DealerHours';
import styles from './styles';

const dayOrder: DaysOfWeek[] = [
  DaysOfWeek.Mon,
  DaysOfWeek.Tue,
  DaysOfWeek.Wed,
  DaysOfWeek.Thu,
  DaysOfWeek.Fri,
  DaysOfWeek.Sat,
  DaysOfWeek.Sun,
];

interface HoursProps {
  hours: DealerHours;
}

export default function Hours({ hours }: HoursProps): JSX.Element {
  const { isOpenToday, todayHours, hours: schedule } = hours;
  const { t } = useTranslation();
  const [isFullHoursOpen, setIsFullHoursOpen] = useState<boolean>();
  const currentDay = DayOrder[new Date().getDay()];

  return (
    <div className="hours">
      <header className="header">
        <Icon image={clockIcon} />
        <div className="today">
          <div className="title" data-testid="today-status">
            {isOpenToday ? t('dealerPages.openToday') : t('dealerPages.closedToday')}
          </div>
          <div className="flex">{isOpenToday && <Day hours={todayHours} isOpen={true} />}</div>
        </div>
      </header>
      <div className="full-hours-container">
        <button
          className={`dealer-contact-hours-button toggle-hours show-hours ${
            isFullHoursOpen ? 'hidden' : ''
          }`}
          data-testid="show-hours"
          onClick={(): void => {
            setIsFullHoursOpen(true);
          }}
        >
          {t('dealerPages.showAllHours')}
        </button>
        <table data-testid="full-hours" className={`full-hours ${isFullHoursOpen ? 'open' : ''}`}>
          <tbody>
            {dayOrder.map((day) => {
              const dayHours = schedule[day];
              const isToday = day === currentDay;

              return <WeekRow day={day} hours={dayHours} isToday={isToday} key={day} />;
            })}
          </tbody>
        </table>
        <button
          className={`dealer-contact-hours-button toggle-hours hide-hours ${
            isFullHoursOpen || 'hidden'
          }`}
          data-testid="hide-hours"
          onClick={(): void => {
            setIsFullHoursOpen(false);
          }}
        >
          {t('dealerPages.hideAllHours')}
        </button>
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}
